const MERCHANT_CREATOR = 'merchant-super';

const MERCHANT_MANAGER = 'merchant-admin';

const COMMUNE_CREATOR = 'commune-super';

const COMMUNE_MANAGER = 'commune-admin';

export {MERCHANT_MANAGER, MERCHANT_CREATOR, COMMUNE_MANAGER, COMMUNE_CREATOR}